import AppAdmin from '../components/admin/AppAdmin';


const HomeRoutes = [
  {path: '/', component: AppAdmin, exact: false, public:true}
];

export const routes = HomeRoutes;
